/*
  Brevitē corporate page (page.b2b-v2). Loaded only on that template.
  1. Keeps --b2b-header-h equal to the sticky header's height, so scrolling to
     #inquiry stops below the header instead of under it.
  2. Pushes { event: 'b2b_cta_click', location } to dataLayer when any link to
     #inquiry is clicked. location comes from the nearest data-b2b-section.
*/
(function () {
  var root = document.body;

  function setHeaderHeight() {
    var header = document.querySelector('.section-header') || document.querySelector('sticky-header');
    if (!header) return;
    root.style.setProperty('--b2b-header-h', Math.round(header.getBoundingClientRect().height) + 'px');
  }
  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight, { passive: true });
  window.addEventListener('load', setHeaderHeight);

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href]');
    if (!link) return;
    var href = link.getAttribute('href') || '';
    if (href.slice(-8) !== '#inquiry') return;

    var section = link.closest('[data-b2b-section]');
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'b2b_cta_click',
      location: section ? section.getAttribute('data-b2b-section') : 'other'
    });

    // Recompute right before the jump; the header shrinks once the page scrolls.
    setHeaderHeight();
  });
})();
